
















import {Component, Emit, Prop, Vue} from "vue-property-decorator";
import Cognito from "@/authorization/cognito";
import Translate from "@/consoleapi/api/translate";

import {CognitoUser} from "amazon-cognito-identity-js";

@Component
export default class AccountInput extends Vue {
    @Prop() public cognito!: Cognito;
    @Prop() public cognitoUser!: CognitoUser;

    private email = '';

    @Emit()
    public inputCognitoUserEmit(inputCognitoUser: CognitoUser) {
        // console.log(inputCognitoUser.getUsername());
    }

    goConfirmPage(event: Event) {
        if (event) {
            event.preventDefault()
        }
        if(!this.validation()) {
            return;
        }
        const cognitoUser = this.cognito.getCognitoUser(this.email);
        this.inputCognitoUserEmit(cognitoUser);
        this.cognito.forgotPassword(cognitoUser).then(() => {
            this.$store.dispatch('changePassword/pushProgress', 'result');
        }).catch((err) => {
            this.translate(err.message || JSON.stringify(err));
            return;
        });
        this.$store.dispatch('forgotPassword/pushProgress', 'confirm');
    }

    private validation(){
        if (this.email === '') {
            alert('アカウントIDを入力してください');
            return false;
        }
        return true;
    }

    translate(message: string) {
        const translate = new Translate();
        translate.get(message)
            .then(response => {
                alert(response.data.text);
            })
            .catch(error => {
                //console.log(error.response);
                alert(message);
            })
    }
}
